import { render, staticRenderFns } from "./DosingCTAcontent.vue?vue&type=template&id=c2ba4584"
import script from "./DosingCTAcontent.vue?vue&type=script&lang=js"
export * from "./DosingCTAcontent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports